import { Injectable } from "@angular/core";
import {
    RequestOptions, Headers, RequestMethod, Http, URLSearchParams,
    ResponseContentType, Request
} from "@angular/http";
import { Cookie } from "ng2-cookies";
import { ConfigService } from "./configService";
import { Configuration } from "../objects/common/configuration";
import { BaseApi } from "./baseService";
import {HttpEvent, HttpHeaders, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs";
import {SelfServeFileType} from "../objects/documents/SelfServeFileType";
import {DocumentFile} from "../objects/documents/DocumentFile";
import {BaseResponse} from "../objects/common/baseResponse";

/**
 * Created by alex.y on 10/3/2017.
 */

@Injectable()
export class UploadService extends BaseApi {
    protected config: Configuration;

    constructor(http: Http, configService: ConfigService) {
        super(http, configService);
    }

    public downloadFile(fileName: string = null, url: string = 'upload', additionalParams: { param: string, val: string }[] = [], downloadFileName: string = null): Promise<{}> {
        let params = new RequestOptions();

        params.headers = new Headers();
        params.headers.append("Content-Type", 'application/json');
        params.headers.append("Authorization", `Bearer ` + Cookie.get(this.config.ApiTokenCookieName));

        params.method = RequestMethod.Get;

        params.url = `${this.config.ApiUrl}/${url}`;
        params.params = new URLSearchParams();

        if (fileName)
            params.params.append('filename', fileName);

        if (additionalParams.length > 0)
            additionalParams.forEach(p => params.params.append(p.param, p.val));

        params.responseType = ResponseContentType.Blob;

        return this.http.get(params.url, params).toPromise().then((res: any) => {
            let url = window.URL.createObjectURL(res.blob());

            let link = document.createElement('a');

            link.href = url;

            if(fileName)
                link.download = fileName.substring(37);
            else
                link.download = downloadFileName;

            link.click();

            return new Promise((resolve, reject) => resolve(true));
        });
    }

    public exportOrders(fileName: string, dateFrom?: any, dateTo?: any): Promise<{}> {
        let paramArray :{ param: string, val: string }[] = [];

        if(dateFrom)
            paramArray.push({
                param: 'from',
                val: (new Date(dateFrom)).toLocaleDateString()
            });

        if(dateTo)
            paramArray.push({
                param: 'to',
                val: (new Date(dateTo)).toLocaleDateString()
            });

        return this.downloadFile(fileName, "upload/export/order", paramArray )
    }

    public downloadDocument(id: string, type : 'CBP7501' | 'CBP3461'): Promise<{}>{
        return this.downloadFile(null, `upload/export/${type}/${id}`, [], type);
    }

    public uploadCustomers(uploadData: FormData): Promise<any> {
        let params = new RequestOptions();

        params.headers = new Headers();
        params.headers.append("Authorization", `Bearer ` + Cookie.get(this.config.ApiTokenCookieName));

        params.method = RequestMethod.Post;

        const url = `${this.config.ApiUrl}/upload/customers`;
        return this.http.post(url, uploadData, params).toPromise();
    }

    public uploadFile(orderId: number, type: SelfServeFileType, file: any): Observable<any> {
        const uploadData = new FormData();
        uploadData.append('files', file, file.name);

        const req = new Request({
            url: `${this.config.ApiUrl}/upload/vehicle?orderId=${orderId}&type=${type}&name=${file.name}`,
            method: RequestMethod.Post,
            headers: new Headers({
                Authorization: `Bearer ${Cookie.get(this.config.ApiTokenCookieName)}`
            }),
            body: uploadData
        });

        return this.http.request(req);
    }

    public getAllFiles(orderId: number): Promise<BaseResponse<DocumentFile[]>> {
        let params = new RequestOptions();

        params.headers = new Headers();
        params.headers.append("Authorization", `Bearer ` + Cookie.get(this.config.ApiTokenCookieName));
        params.url = `upload/vehicle/getFiles/${orderId}`;
        params.method = RequestMethod.Get;

        return this.get(params);
    }
}



// WEBPACK FOOTER //
// ./app/services/uploadService.ts